import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

export const getRoutinesViewConfig = (): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal',
			title: 'Getting started with lesson slides',
			subtitle:
				'Since this is your first time going through a lesson slide, let’s go over a few pointers to get you well prepared.',
			image: '/img/ftux-routines-view-1.png',
			button: {
				label: 'Next',
				type: 'paginated',
				hasBackButton: false
			},
			modalPosition: 'bottom-right',
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#routine-step-button',
			subtitle:
				'Click the arrow to step through each part of the routine and guide your students through the planned content.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#routine-info-button',
			subtitle:
				'If you need help, press the Info button here to learn more about this teaching routine and how to best teach it.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'routines-view-ftux',
		name: 'Routines View Tutorial',
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
